<template>
  <v-layout justify-center>
    <v-btn color="info" href="mailto:info@thrasker.com">
      Contact us!
    </v-btn>
  </v-layout>
</template>

<script>
export default {};
</script>

<style>
</style>
